<template>
  <header
    ref="headerRef"
    class="bg-base-100 sticky top-0 z-40 flex max-h-12 min-h-12 items-center justify-center gap-4 border-b p-2 md:hidden print:hidden"
  >
    <MgdSidebarTrigger class="absolute top-1/2 left-2 -translate-y-1/2" />
    <Icon
      name="mgd:midland"
      class="text-primary mx-auto block h-full w-auto fill-current"
    />
  </header>
</template>
